export default "__VITE_ASSET__BV1GK7kg__"